import { Module } from "vuex";

import { IRootState } from "@/store";
import { getters } from "@/store/modules/processUser/getters";
import { actions } from "@/store/modules/processUser/actions";
import { mutations } from "@/store/modules/processUser/mutations";
import { IProcessUserState, state } from "@/store/modules/processUser/state";

export const processUser: Module<IProcessUserState, IRootState> = {
  actions,
  mutations,
  state,
  getters,
};
